export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6777.f1525a18.jpg";